import { Container } from '@mui/material';
import React  from 'react';
import { useParams } from 'react-router-dom';

import NavTabs from '../../../../../components/NavTabs';


export default function NavTabsBlock() {
  const { id } = useParams();
  const tabs = [
    {
      label: 'Cameras',
      value: '/companies/tcam/list/:id',
      to: `/companies/tcam/list/${id}`,
    },
    {
      label: 'OCR Statuses',
      value: '/companies/tcam/ocr/list/:id',
      to: `/companies/tcam/ocr/list/${id}`,
    },
    {
      label: 'TCAM Settings',
      value: '/companies/tcam/settings/:id',
      to: `/companies/tcam/settings/${id}`,
    },
    {
      label: 'BLOB Settings',
      value: '/companies/tcam/blob-url/locations-list/:id',
      to: `/companies/tcam/blob-url/locations-list/${id}`
    },
  ];

  return (
    <>
      <Container
        maxWidth="xl"
        data-test="nav-tabs-block"
      >
        <NavTabs tabs={tabs} />
      </Container>
    </>
  );
}
